const TURNOS_ROUTE_GROUP = [
	'/inicio/programar-turnos',
	'/inicio/turnos',
	'/inicio/gestionar-turnos'
]

const ROUTE_GROUPS = {
	'/inicio/programar-turnos': TURNOS_ROUTE_GROUP,
	'/inicio/turnos': TURNOS_ROUTE_GROUP,
	'/inicio/gestionar-turnos': TURNOS_ROUTE_GROUP
}

const matchesRoutePrefix = (pathname, route) =>
	pathname === route || pathname.startsWith(`${route}/`)

const HOME_RELATED_ROUTES = ['/inicio/novedades']

export const matchesNavigationPath = (pathname, route, relatedRoutes = []) => {
	if (!pathname || !route) return false
	if (route === '/inicio') {
		return (
			pathname === route ||
			HOME_RELATED_ROUTES.some(related => matchesRoutePrefix(pathname, related))
		)
	}

	const groupedRoutes = ROUTE_GROUPS[route] || [route]
	const candidateRoutes = [...new Set([...groupedRoutes, ...relatedRoutes])]

	return candidateRoutes.some(candidateRoute => matchesRoutePrefix(pathname, candidateRoute))
}